import { createReducer } from "@reduxjs/toolkit";
import { updateBatch, resetUpdateBatch } from "./update-batch";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateBatchReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateBatch.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateBatch.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateBatch.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateBatch, () => {
    return initialState;
  });
});
